var React = require('react');

function Code (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M28.484 7.98a1.5 1.5 0 0 0-1.416 1.074l-9 29a1.5 1.5 0 1 0 2.863.891l9-29a1.5 1.5 0 0 0-1.447-1.965zM13.51 12.984a1.5 1.5 0 0 0-1.043.428l-10 9.5a1.5 1.5 0 0 0 0 2.176l10 9.5a1.5 1.5 0 1 0 2.066-2.176L5.678 24l8.855-8.412a1.5 1.5 0 0 0-1.023-2.604zm20.936.002a1.5 1.5 0 0 0-.979 2.602L42.322 24l-8.855 8.412a1.5 1.5 0 1 0 2.066 2.176l10-9.5a1.5 1.5 0 0 0 0-2.176l-10-9.5a1.5 1.5 0 0 0-1.088-.426z"}));
}

Code.defaultProps = {"viewBox":"0 0 48 48","fill":"#000000","xmlnsV":"https://vecta.io/nano"};

module.exports = Code;

Code.default = Code;
